var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('question-layout',{attrs:{"id":"which-jersey-shore"}},[_c('div',{staticClass:"question"},[_c('jersey-question',{attrs:{"text":_vm.question}})],1),_c('jersey-dropdown',{attrs:{"modelName":"castMember","options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }